import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { Scale, Calculator, ShieldCheck, Headset } from "lucide-react";

const TEAM = [
  {
    icon: Scale,
    role: "Avvocati in diritto bancario",
    bio: "Curano le istanze formali di cancellazione, la verifica dei vizi di legittimità e i rapporti con gli istituti segnalanti.",
  },
  {
    icon: Calculator,
    role: "Dottori commercialisti",
    bio: "Analizzano le posizioni, le anomalie contabili e la documentazione richiesta a banche e finanziarie.",
  },
  {
    icon: ShieldCheck,
    role: "Specialisti dei sistemi creditizi",
    bio: "Conoscono a fondo CRIF, Centrale Rischi, CTC e CAI: regole, tempi di conservazione e procedure di rettifica.",
  },
  {
    icon: Headset,
    role: "Consulenti dedicati",
    bio: "Ti seguono passo passo: dalla prima visura fino alla conferma della cancellazione, sempre via email o WhatsApp.",
  },
];

export default function Team() {
  const { t } = useLang();
  return (
    <section id="team" className="py-20 lg:py-28" data-testid="team-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-[#00AEEF]">{t("team.kicker")}</p>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#003087] mt-3">{t("team.title")}</h2>
          <p className="mt-4 text-base text-[#64748B]">{t("team.sub")}</p>
        </motion.div>
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {TEAM.map((m, i) => (
            <motion.article key={m.role}
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.55, delay: i * 0.1 }}
              className="card rounded-3xl p-6 text-center" data-testid={`team-member-${i + 1}`}>
              <div className="w-20 h-20 mx-auto rounded-full bg-[#003087] border-2 border-[#00AEEF]/40 flex items-center justify-center" data-testid={`team-avatar-${i + 1}`}>
                <m.icon size={34} className="text-[#00AEEF]" />
              </div>
              <p className="font-bold text-[#003087] mt-4">{m.role}</p>
              <p className="text-xs text-[#64748B] leading-relaxed mt-2.5">{m.bio}</p>
            </motion.article>
          ))}
        </div>
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-10 text-center text-sm font-semibold text-[#003087] bg-[#E6F6FD] rounded-2xl px-6 py-4 max-w-3xl mx-auto" data-testid="team-note">
          {t("team.note")}
        </motion.p>
      </div>
    </section>
  );
}
